import { ApiProperty } from '@nestjs/swagger';
import { IsNumber, Min } from 'class-validator';

/**
 * DTO for updating the price of an existing deal.
 */
export class DealPriceUpdateRequest {
  @ApiProperty({
    description: 'New price for the deal. Must be a non-negative number.',
    example: 12000,
    minimum: 0,
  })
  @IsNumber()
  @Min(0)
  price: number;
}
